import makeStyles from '@mui/styles/makeStyles';

export default makeStyles(theme => ({
  itemButton: {
    ...theme.typography.caption1,
    marginRight: theme.spacing(2),
    color: theme.palette.secondary[500],
    marginLeft: 'auto',
    cursor: 'pointer',
    whiteSpace: 'nowrap'
  }
}));
